import React from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { Button, InputContainer, SendToast } from "@networkraildigitalfactory/components";
import cloudURL from "../../services/cloud";
import DFLogo from "../../assets/DFLogoLarge.png";
import TrackImg from "../../assets/Track.png";
import styles from "./Login.module.css";

const Login = (props) => {
  const { updateUser } = props;

  const __redirectUser__ = async (isValidLM, isValidEmp) => {
    let pushTo;
    if (isValidEmp) {
      pushTo = "my-objectives/objectives";
      if (isValidLM) {
        pushTo = "/my-team";
        if (localStorage.getItem("lineManagerRedirect") !== null) {
          const lineManagerRedirect = localStorage.getItem("lineManagerRedirect");
          pushTo = lineManagerRedirect;
        }
      }
      if (localStorage.getItem("emp121Redirect") !== null) {
        const emp121Redirect = localStorage.getItem("emp121Redirect");
        pushTo = emp121Redirect;
      } else if (localStorage.getItem("empObjRedirect") !== null) {
        const empObjRedirect = localStorage.getItem("empObjRedirect");
        pushTo = empObjRedirect;
      } else if (localStorage.getItem("notificationsRedirect") !== null) {
        const notificationsRedirect = localStorage.getItem("notificationsRedirect");
        pushTo = notificationsRedirect;
      }
    } else {
      pushTo = "/";
    }
    props.history.push(pushTo);
  };

  const onLogin = async (data) => {
    props.setLoading(true, "Logging in...");
    try {
      const resp = await axios({
        method: "POST",
        url: `${cloudURL()}/login`,
        data,
      });

      axios.defaults.headers.common.iperform = "FakeIPerformHeader";

      localStorage.setItem("authenticated", true);
      localStorage.setItem("user", JSON.stringify(resp));
      props.setAuthenticated(true);
      updateUser(resp.data);
      const isLineManager = await props.setIsLineManager();
      props.setLoading(false);
      const isValidLM = isLineManager && resp.data.isValidProfile;
      const isValidEmp = resp.data.isValidProfile;
      __redirectUser__(isValidLM, isValidEmp);
      if (resp.data.firstLogin) {
        props.setFirstLogin(true);
      }
    } catch (e) {
      console.error("err: ", e);
      props.setLoading(false);
      if (e.toString().includes("50")) {
        SendToast("An issue occured with the AD auth service", "error");
      } else {
        SendToast("Please check that you entered your details correctly", "error");
      }
    }
  };

  const { register, handleSubmit, errors } = useForm();

  document.onkeypress = function (e) {
    if (e.keyCode === 13) {
      handleSubmit(onLogin);
    }
  };

  return (
    <div className={styles.Login}>
      <div className={styles.form_panel}>
        <div className={styles.form_header}>
          <h1>iPerform</h1>
        </div>
        <form onSubmit={handleSubmit(onLogin)} className={styles.login_form}>
          <InputContainer
            forLabel="userName"
            labelText="Username"
            exampleText="For example JBloggs2"
            errorText={errors?.userName ? errors.userName.message : null}
            required
          >
            <input
              className={`${styles.form_input} ${errors?.userName ? styles.error : ""}`}
              id="userName"
              name="userName"
              type="text"
              autoComplete="username"
              ref={register({
                required: "Must not be blank",
              })}
            />
          </InputContainer>
          <InputContainer
            forLabel="userPassword"
            labelText="Password"
            errorText={errors?.userPassword ? errors.userPassword.message : null}
            required
          >
            <input
              className={`${styles.form_input} ${errors?.userPassword ? styles.error : ""}`}
              id="userPassword"
              name="userPassword"
              type="password"
              autoCapitalize="current-passowrd"
              ref={register({
                required: "Must not be blank",
              })}
            />
          </InputContainer>
          <Button
            role="button"
            color="blue"
            name="login"
            text="Login"
            onClick={() => {}}
            style={{ marginTop: "1rem" }}
          />
        </form>
        <div className={styles.statements_wrapper}>
          <a
            href="https://networkrailmobile-gdpr.s3.eu-west-2.amazonaws.com/iPerform-PrivacyStatement.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Statement
          </a>
          <a
            href="https://networkrailmobile-accessibility.s3.eu-west-2.amazonaws.com/iPerform/iPerform+Accessibility+Statement.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Accessibility Statement
          </a>
        </div>
        {!isMobile && (
          <div className={styles.form_panel_footer}>
            <img src={DFLogo} alt="Digital Factory Logo" />
          </div>
        )}
      </div>
      <div className={styles.info_panel}>
        <div className={styles.info_header}>
          <h2>
            Personal performance
            <br />
            review tool.
          </h2>
          <h3 style={{ fontSize: "24px" }}>
            iPerform allows employees and <br /> managers to set objectives and review <br /> their
            progress through each 1-2-1
          </h3>
        </div>
        <div className={styles.notice_box}>
          <h3>PLEASE READ THE NOTICE BELOW</h3>
          <p>
            <strong>DDaT Band 1–4 staff:</strong> Please use the following link to access the new
            system:{" "}
            <a
              href="https://networkrail-accessportal.oncreate.app/login_sso?return_to=xSG_wd99UK6xEGEadIsAGH3W0uSyjp-r8aNGzuQMsQxrzAdRNH2SHR7qH1pW0wey6h5NWGyQVEK4aMwdjyFa92WHVfOrw1RpDrPkpkZ8714%3AmIe0GmwiYwX1Sd_zP3Dt_A"
              target="_blank"
              rel="noopener noreferrer"
            >
              New iPerform
            </a>
          </p>
          <p>
            <strong>DDaT Line Managers:</strong> You must not use the New iPerform system to
            complete performance management for your Band 5–8 direct reports. Please use this
            existing system.
          </p>
          <p>
            <strong>All other employees:</strong> Please continue to use this version of iPerform
            until further notice.
          </p>
        </div>
        <div className={styles.info_icon_wrapper}>
          <img src={TrackImg} alt="Train Track" />
        </div>
        {isMobile && (
          <div className={styles.info_panel_footer}>
            <img src={DFLogo} alt="Digital Factory Logo" />
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(Login);
